const TrendFlat = () => (
  <>
    <path
      fill="currentColor"
      d="M19.079 12.5H4.5a.48.48 0 0 1-.357-.143A.48.48 0 0 1 4 12q0-.213.143-.357A.48.48 0 0 1 4.5 11.5h14.579l-2.24-2.246a.48.48 0 0 1 .006-.707q.165-.16.356-.163a.47.47 0 0 1 .351.162l2.883 2.889q.242.242.242.565t-.242.566l-2.889 2.888a.5.5 0 0 1-.341.15.48.48 0 0 1-.366-.15.5.5 0 0 1-.166-.357q0-.19.166-.356z"
    />
  </>
)
export default TrendFlat
